import { css } from 'lit';

export const styles = css`
	:host {
		--_sds-textarea-background-color: var(--sds-textarea-background-color, var(--sds-color-background-default, var(--sds-color-neutral-background-default)));
		--_sds-textarea-text-color: var(--sds-textarea-text-color, var(--sds-color-text-default, var(--sds-color-neutral-text-default)));

		--_sds-textarea-border-color: var(--sds-textarea-border-color, var(--sds-color-border-default, var(--sds-color-neutral-border-default)));
		--_sds-textarea-border-width: var(--sds-textarea-border-width, var(--sds-border-sm));
		--_sds-textarea-border-radius: var(--sds-textarea-border-radius, var(--sds-radius-sm));

		--_sds-textarea-font-family: var(--sds-textarea-font-family, var(--sds-typography-font-family-roboto));
		--_sds-textarea-font-size: var(--sds-textarea-font-size, var(--sds-components-font-size-content-md));
		--_sds-textarea-font-weight: var(--sds-textarea-font-weight, var(--sds-typography-font-weight-regular));
		--_sds-textarea-line-height: var(--sds-textarea-line-height, var(--sds-components-line-height-tall-content-md));
		--_sds-textarea-min-height: var(--sds-textarea-height, var(--sds-components-button-md));

		--_sds-textarea-gap: var(--sds-textarea-gap, var(--sds-spacing-3xs));
		--_sds-textarea-padding-block: var(--sds-textarea-padding-block, var(--sds-spacing-2xs));
		--_sds-textarea-padding-inline: var(--sds-textarea-padding-inline, var(--sds-spacing-2xs));
		--_sds-textarea-disabled-opacity: var(--sds-textarea-disabled-opacity, var(--sds-color-states-disabled-opacity));

		--_sds-textarea-label-text-color: var(--sds-textarea-label-text-color, var(--sds-color-text-default, var(--sds-color-neutral-text-default)));
		--_sds-textarea-label-font-size: var(--sds-textarea-label-font-size, var(--sds-components-font-size-content-md));
		--_sds-textarea-label-font-weight: var(--sds-textarea-label-font-weight, var(--sds-typography-font-weight-medium));
		--_sds-textarea-label-line-height: var(--sds-textarea-label-line-height, var(--sds-components-line-height-squeezed-md));

		--_sds-textarea-label-gap: var(--sds-textarea-gap, var(--sds-spacing-4xs));

		--_sds-textarea-helptext-text-color: var(--sds-textarea-helptext-text-color, var(--sds-color-text-subtle, var(--sds-color-neutral-text-subtle)));
		--_sds-textarea-helptext-font-size: var(--sds-textarea-helptext-font-size, var(--sds-components-font-size-content-md));
		--_sds-textarea-helptext-font-weight: var(--sds-textarea-helptext-font-weight, var(--sds-typography-font-weight-regular));
		--_sds-textarea-helptext-line-height: var(--sds-textarea-helptext-line-height, var(--sds-components-line-height-squeezed-md));

		--_sds-textarea-counter-text-color: var(--sds-textarea-counter-text-color, var(--sds-color-text-default, var(--sds-color-neutral-text-default)));
		--_sds-textarea-counter-font-size: var(--sds-textarea-counter-font-size, var(--sds-components-font-size-content-md));
		--_sds-textarea-counter-font-weight: var(--sds-textarea-counter-font-weight, var(--sds-typography-font-weight-regular));
		--_sds-textarea-counter-line-height: var(--sds-textarea-counter-line-height, var(--sds-components-line-height-squeezed-md));

		--_sds-textarea-focus-color: var(--sds-textarea-focus-color, var(--sds-color-states-focus-outer));
		--_sds-textarea-focus-inner-color: var(--sds-textarea-focus-inner-color, var(--sds-color-states-focus-inner));
		--_sds-textarea-focus-spacing: var(--sds-textarea-focus-spacing, var(--sds-color-states-focus-spacing));

		all: unset;
		display: block;
		text-align: start;
	}

	.sds-textarea {
		display: flex;
		flex-direction: column;
		gap: var(--_sds-textarea-gap);
		font-family: var(--_sds-textarea-font-family);

		.sds-textarea__input-container {
			max-width: var(--sds-typography-max-line-width);
			position: relative;
		}

		.sds-textarea__input {
			box-sizing: border-box;
			color: var(--_sds-textarea-text-color);
			padding: var(--_sds-textarea-padding-block) var(--_sds-textarea-padding-inline);
			line-height: var(--_sds-textarea-line-height);
			font-size: var(--_sds-textarea-font-size);
			font-weight: var(--_sds-textarea-font-weight);
			font-family: var(--_sds-textarea-font-family);
			justify-content: flex-end;
			border-radius: var(--_sds-textarea-border-radius);
			border: var(--_sds-textarea-border-width) solid var(--_sds-textarea-border-color);
			background: var(--_sds-textarea-background-color);
			max-width: var(--sds-typography-max-line-width);
			width: 100%;
			min-height: var(--_sds-textarea-min-height);
			resize: vertical;

			&:hover {
				--_sds-textarea-border-color: var(--sds-textarea-border-color, var(--sds-color-action-hover, var(--sds-color-main-action-hover)));
			}

			&:focus-visible {
				box-shadow: 0 0 0 var(--sds-color-states-focus-spacing) var(--_sds-textarea-focus-inner-color);
				outline: 3px solid var(--_sds-textarea-focus-color);
				outline-offset: 3px;
			}

			&:active {
				--_sds-textarea-border-color: var(--sds-textarea-border-color, var(--sds-color-action-active, var(--sds-color-main-action-active)));
				--_sds-textarea-text-color: var(--sds-textarea-text-color, var(--sds-color-text-default, var(--sds-color-main-text-default)));
			}
		}

		.sds-textarea__label {
			color: var(--_sds-textarea-label-text-color);
			display: block;
			font-size: var(--_sds-textarea-label-font-size);
			font-weight: var(--_sds-textarea-label-font-weight);
			line-height: var(--_sds-textarea-label-line-height);
			max-width: var(--sds-typography-max-line-width);
		}

		.sds-textarea__help-text {
			color: var(--_sds-textarea-helptext-text-color);
			font-size: var(--_sds-textarea-helptext-font-size);
			font-weight: var(--_sds-textarea-helptext-font-weight);
			line-height: var(--_sds-textarea-helptext-line-height);
			margin: 0;
			max-width: var(--sds-typography-max-line-width);
		}

		*:has(.sds-textarea__label) {
			display: flex;
			flex-direction: column;
			gap: var(--_sds-textarea-label-gap);
		}

		.sds-textarea__character-counter {
			color: var(--_sds-textarea-counter-text-color);
			font-size: var(--_sds-textarea-counter-font-size);
			font-weight: var(--_sds-textarea-counter-font-weight);
			line-height: var(--_sds-textarea-counter-line-height);
			margin: 0;
			max-width: var(--sds-typography-max-line-width);
		}

		&.sds-textarea--error {
			--_sds-textarea-border-color: var(--sds-textarea-border-color, var(--sds-color-alert-danger-border-default));
			--_sds-textarea-counter-text-color: var(--sds-textarea-counter-text-color, var(--sds-color-alert-danger-text-subtle));

			& .sds-textarea__input:hover {
				--_sds-textarea-border-color: var(--sds-textarea-border-color, var(--sds-color-alert-danger-action-hover));
				--_sds-textarea-text-color: var(--sds-textarea-text-color, var(--sds-color-alert-danger-text-default));
			}

			& .sds-textarea__input:active {
				--_sds-textarea-border-color: var(--sds-textarea-border-color, var(--sds-color-alert-danger-action-active));
			}

			& :is(sds-alert) {
				--sds-alert-padding: 0px;
			}
		}
	}

	:host([readonly]) {
		--_sds-textarea-background-color: var(--sds-textarea-background-color, var(--sds-color-surface-tinted, var(--sds-color-neutral-surface-tinted)));
		--_sds-textarea-border-color: var(--sds-textarea-border-color, var(--sds-color-border-subtle, var(--sds-color-neutral-border-subtle)));
		.sds-textarea__input {
			resize: none;
		}
	}

	:host([disabled]) {
		opacity: var(--_sds-textarea-disabled-opacity);
		pointer-events: none;
	}

	:host([size='sm']) {
		--_sds-textarea-font-size: var(--sds-textarea-font-size, var(--sds-components-font-size-content-sm));
		--_sds-textarea-line-height: var(--sds-textarea-line-height, var(--sds-components-line-height-tall-content-sm));
		--_sds-textarea-min-height: var(--sds-textarea-height, var(--sds-components-button-sm));

		--_sds-textarea-label-line-height: var(--sds-textarea-label-line-height, var(--sds-components-line-height-squeezed-sm));
		--_sds-textarea-label-font-size: var(--sds-textarea-label-font-size, var(--sds-components-font-size-content-sm));

		--_sds-textarea-helptext-font-size: var(--sds-textarea-helptext-font-size, var(--sds-components-font-size-content-sm));
		--_sds-textarea-helptext-line-height: var(--sds-textarea-helptext-line-height, var(--sds-components-line-height-squeezed-sm));

		--_sds-textarea-counter-font-size: var(--sds-textarea-counter-font-size, var(--sds-components-font-size-content-sm));
		--_sds-textarea-counter-line-height: var(--sds-textarea-counter-line-height, var(--sds-components-line-height-squeezed-sm));
	}

	:host([size='lg']) {
		--_sds-textarea-font-size: var(--sds-textarea-font-size, var(--sds-components-font-size-content-lg));
		--_sds-textarea-line-height: var(--sds-textarea-line-height, var(--sds-components-line-height-tall-content-lg));
		--_sds-textarea-min-height: var(--sds-textarea-height, var(--sds-components-button-lg));

		--_sds-textarea-label-line-height: var(--sds-textarea-label-line-height, var(--sds-components-line-height-squeezed-lg));
		--_sds-textarea-label-font-size: var(--sds-textarea-label-font-size, var(--sds-components-font-size-content-lg));

		--_sds-textarea-helptext-font-size: var(--sds-textarea-helptext-font-size, var(--sds-components-font-size-content-lg));
		--_sds-textarea-helptext-line-height: var(--sds-textarea-helptext-line-height, var(--sds-components-line-height-squeezed-lg));

		--_sds-textarea-counter-font-size: var(--sds-textarea-counter-font-size, var(--sds-components-font-size-content-lg));
		--_sds-textarea-counter-line-height: var(--sds-textarea-counter-line-height, var(--sds-components-line-height-squeezed-lg));
	}
`;
